import {IdObjectsWithId} from "../../utils";

export type SampleFeedManager = {
    [key: string]: SampleFeed
}

export interface IFeed {
    id: string;
    name: string;
    preview: SampleFeedList
}

export type SampleFeed = {
    [key: string]: SampleFeedRow
}

export type SampleFeedList = Array<SampleFeedRow>

export type SampleFeedRow = {
    Id: string;
    Name?: string;
    ImageUrl?: string;
    Price?: string;
    ReducedPrice?: string;
    Sale?: string;
    Deeplink?: string;
    RecommendedId?: string;
}

export interface IActiveFeed extends IFeed {
    json: string;
}

export interface IFeedState {
    readonly liveFeeds: IdObjectsWithId<IFeed>;
    readonly sampleFeeds: IdObjectsWithId<IFeed>;
    // readonly liveFeedManager: SampleFeedManager;
    // readonly sampleFeedManager: SampleFeedManager;
    readonly activeFeed: IActiveFeed;
}

export enum FeedType {
    LIVE = "liveFeeds",
    SAMPLE = "sampleFeeds",
}
